export const authenticateUser = (state = null, action) => {
  if (action.type === "authenticateUser") {
    return (state = action.payload);
  } else {
    return state;
  }
};

export const switchedSociety = (state = null, action) => {
  if (action.type === "switchedSociety") {
    return (state = action.payload);
  } else {
    return state;
  }
};

export const groupWiseLevelData = (state = null, action) => {
  if (action.type === "groupWiseLevelData") {
    return (state = action.payload);
  } else {
    return state;
  }
};

export const userHasSocieties = (state = null, action) => {
  if (action.type === "userHasSocieties") {
    return (state = action.payload);
  } else {
    return state;
  }
};
export const userHasRoleWithPermission = (state = null, action) => {
  if (action.type === "userHasRoleWithPermission") {
    return (state = action.payload);
  } else {
    return state;
  }
};

export const switchedRole = (state = null, action) => {
  if (action.type === "switchedRole") {
    return (state = action.payload);
  } else {
    return state;
  }
};
